var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadSmile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 96,
    viewBox: "0 0 172 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.749 73.0002C133.755 72.8652 134.726 72.4156 135.506 71.6502C137.424 69.7677 137.452 66.6872 135.569 64.7698C117.052 45.9091 97.3326 41.7007 80.1855 44.5446C63.3555 47.3358 49.4169 56.831 41.625 64.7704C40.0617 66.3634 39.8168 68.7584 40.8776 70.6027C51.4268 57.381 67.6775 48.9089 85.9069 48.9089C105.216 48.9088 122.304 58.4139 132.749 73.0002Z",
    fill: "#EF426D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.697 21.8418C113.722 20.3438 112.898 17.1835 109.405 16.5264C106.738 15.9827 101.09 16.139 99.8395 21.113",
    stroke: "#EF426D",
    strokeWidth: 2.88079,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2969 20.5898C81.5066 19.1064 81.0797 15.8686 77.6946 14.7848C75.1145 13.9157 69.4907 13.373 67.6353 18.1543",
    stroke: "#EF426D",
    strokeWidth: 2.88079,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.558 63.5C139.864 66.0609 133.072 71.6186 127.455 73.3622",
    stroke: "#EF426D",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6523 74.1855C45.4466 72.3044 38.2281 67.3132 34.9999 62.3971",
    stroke: "#EF426D",
    strokeWidth: 5.76159,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadSmile);
export default __webpack_public_path__ + "static/media/badSmile.08aec3b4e85773d9009ee0d7ba817d50.svg";
export { ForwardRef as ReactComponent };